import router from "./router";
import { apiGameLogin, getRoleList, apiWechatLogin } from "@/api/user";
import { showLoading, hideLoading } from "@/utils/loading";
import storage from "@/utils/storage";

router.beforeEach((to, from, next) => {
  // 微信自动绑定逻辑
  if (to.query.wechat_auto_bind) {
    const redirectUrl = encodeURIComponent(
      "http://kf.yingxiong.com/select-game"
    );
    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe0e7d624cb5ad446&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
    window.open(url, "_self");
  }
  // 如果url带code，则是微信回调回来的code，用来校验微信用户信息
  if (to.query.code) {
    apiWechatLogin({ code: to.query.code })
      .then((res) => {
        if (res.code === 0 && res.data) {
          if (res.data.token) {
            storage.removeItem("token");
            storage.setItem("token", res.data.token);
          } else {
            if (res.data.open_id) {
              sessionStorage.setItem("open_id", res.data.open_id);
            }
          }

          next({
            path: to.path,
            query: {
              ...to.query,
              code: undefined,
            },
          });
        } else {
          next({
            path: to.path,
            query: {
              ...to.query,
              code: undefined,
            },
          });
        }
      })
      .catch(() => {
        next({
          path: to.path,
          query: {
            ...to.query,
            code: undefined,
          },
        });
      });
  }
  // 自动绑定逻辑
  const { data, game_id } = to.query;
  if (data && game_id) {
    showLoading();
    apiGameLogin({ data, game_id })
      .then((res) => {
        if (res.code === 0) {
          storage.removeItem("token");
          storage.setItem("token", res.data.token);
          sessionStorage.setItem("game_id", Number(game_id));
          console.log("2222", to.name);
          hideLoading();
          if (to.name === "Login") {
            next({
              path: "/user-center",
              query: {
                ...to.query,
                data: undefined,
              },
            });
          } else {
            next({
              path: to.path,
              query: {
                ...to.query,
                data: undefined,
              },
            });
          }
          // getRoleList()
          //   .then(() => {

          //     // if (res.code === 0) {
          //     //   next({
          //     //     path: to.path,
          //     //     query: {
          //     //       ...to.query,
          //     //       data: undefined,
          //     //     },
          //     //   });
          //     // } else {
          //     //   next({
          //     //     path: to.path,
          //     //     query: {
          //     //       ...to.query,
          //     //       data: undefined,
          //     //     },
          //     //   });
          //     // }
          //   })
          //   .catch(() => {
          //     next({
          //       path: to.path,
          //       query: {
          //         ...to.query,
          //         data: undefined,
          //       },
          //     });
          //   })
          //   .finally(() => {
          //     hideLoading();
          //   });
        } else {
          hideLoading();
          next({
            path: to.path,
            query: {
              ...to.query,
              data: undefined,
            },
          });
        }
      })
      .catch(() => {
        console.log("3333", to.name);
        hideLoading();
        next();
      });
  } else {
    next();
  }
});
